import { TApiResponse, TPager } from "@/types";
import http from "@/http";

export async function getInspections(options?: {
    search?: string,
    pager?: TPager,
    filter?: Record<string, any>
}) {
    const response = await http.get<TApiResponse<any>>("/inspections", {
        params: {
            "search": options?.search,
            ...options?.pager,
            ...options?.filter
        }
    });
    return response.data;
}

export async function getInspectionDetails(inspectionId: string) {
    const response = await http.get<TApiResponse<any>>(`/inspections/${inspectionId}`);
    return response.data;
}

export async function createInspection(data: any) {
    const response = await http.post<TApiResponse<any>>("/inspections", data);
    return response.data;
}

export async function updateInspection(inspectionId: string, data: any) {
    const response = await http.put<TApiResponse<any>>(`/inspections/${inspectionId}`, data);
    return response.data;
}

export async function deleteInspection(inspectionId: string) {
    const response = await http.delete<TApiResponse<any>>(`inspections/${inspectionId}`);
    return response.data;
}